
import { FilePlus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import SummaryCards from "@/components/dashboard/home/SummaryCards";
import ProfileCompletionCard from "@/components/dashboard/home/ProfileCompletionCard";
import DashboardTabs from "@/components/dashboard/home/DashboardTabs";
import ActivitySection from "@/components/dashboard/home/ActivitySection";
import UpcomingEvents from "@/components/dashboard/home/UpcomingEvents";

const DashboardHome = () => {
  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Dashboard</h1>
          <p className="text-muted-foreground">Welcome back to your property management dashboard.</p>
        </div>
        <Button asChild>
          <Link to="/dashboard/add-listing">
            <FilePlus className="mr-2 h-4 w-4" />
            Add New Listing
          </Link>
        </Button>
      </div>
      
      {/* Summary Cards */}
      <SummaryCards />
      
      {/* Profile Completion Call-to-Action */}
      <ProfileCompletionCard />
      
      {/* Tabs section for Properties and Inquiries */}
      <DashboardTabs />
      
      {/* Upcoming & Activity Section */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* Recent Activity */}
        <ActivitySection />
        
        {/* Upcoming Calendar */}
        <UpcomingEvents />
      </div>
    </div>
  );
};

export default DashboardHome;
